import { render } from "./ItemProfileBidList.vue?vue&type=template&id=66058f48&scoped=true"
import script from "./ItemProfileBidList.vue?vue&type=script&lang=ts"
export * from "./ItemProfileBidList.vue?vue&type=script&lang=ts"

import "./ItemProfileBidList.vue?vue&type=style&index=0&id=66058f48&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-66058f48"

export default script